<template>
  <div>
    <form-input-container
      :title="$t('period.form.start-date')"
      text='De ingangsdatum van de wijziging die u door gaat voeren.'>

      <date-picker
        v-model="startDate"
        :min="minDate"
        :max="new Date().toISOString().substr(0, 10)" />
    </form-input-container>

    <form-input-container
      :title="$t('report-of-sickness.disability-rate')"
      :text="$t('report-of-sickness.form.disability-rate-description')">
      <text-field
        placeholder="XXX,XX" right
        v-model="disabilityRate"
        @change="handleDisabilityRateChanged"
        :errors="validations.messagesFor('disabilityRate')">
        <p slot="right">%</p>
      </text-field>
    </form-input-container>
  </div>
</template>

<script>
import New from '@/views/constants/period-new';
import Edit from '@/views/constants/period-edit';
import States from '@/resources/models/states';

import Compositions from '@/views/helpers/compositions';
import Helpers from '@/shared/helpers/functions';
import Modal from '@/shared/constants/modal';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';


import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

export default {
  name: 'PeriodForm',
  props: {
    isEditing: Boolean,
    reportOfSickness: Object
  },
  components: {
    TextField,
    FormInputContainer,
    DatePicker
  },
  computed: {
    minDate () {
      let minimalReportOfSicknessDate = null;
      // adding 1 day to ensure a the date is the actual minimum
      // -> cannot add new report on date itself.
      if (this.isEditing) {
        minimalReportOfSicknessDate = Helpers.Dates.addDays(
          Compositions.getSecondLastDateFromReportOfSickness(this.reportOfSickness), 1);
      } else {
        minimalReportOfSicknessDate = Helpers.Dates.addDays(
          Compositions.getLatestDateFromReportOfSickness(this.reportOfSickness), 1);
      }

      return minimalReportOfSicknessDate;
    },

    validations () {
      if (this.isEditing) {
        return this.$store.getters.editPeriodValidations;
      } else {
        return this.$store.getters.newPeriodValidations;
      }
    },

    period () {
      let result = null;
      if (this.isEditing) {
        result = this.$store.getters.editPeriod;
      } else {
        result = this.$store.getters.newPeriod;
      }
      return result;
    },

    formattedDate () {
      return Helpers.Dates.formatDate(this.startDate);
    },

    startDate: {
      set (value) {
        const latestIndemnity = Compositions.getLatestIndemnityProcessedDate(this.reportOfSickness);
        if (
          latestIndemnity != null &&
          new Date(value) < new Date(latestIndemnity) &&
          this.period.status !== States.Processed
        ) {
          this.$store.dispatch(Modal.Actions.OPEN, {
            component: 'StartDateBeforeIndemnityProcessedPickedForPeriod',
            reportOfSickness: this.reportOfSickness,
            period: this.period,
            isPeriodEditing: this.isEditing,
            newValue: value
          });
        } else {
          if (this.isEditing) {
            this.$store.dispatch(Edit.Actions.Form.CHANGE, { attribute: 'startDate', value: value }).then(
              this.$store.dispatch(Edit.Actions.Steps.Completed.UPDATE));
          } else {
            this.$store.dispatch(New.Actions.Form.CHANGE, { attribute: 'startDate', value: value })
              .then(this.$store.dispatch(New.Actions.Steps.Completed.UPDATE));
          }
        }
      },
      get () {
        return this.period.startDate;
      }
    },
    disabilityRate: {
      set (value) {
        if (value != null) {
          value = value.replace('.', ',');
        }
        if (this.isEditing) {
          this.$store.dispatch(Edit.Actions.Form.CHANGE, { attribute: 'disabilityRate', value: value }).then(
            this.$store.dispatch(Edit.Actions.Steps.Completed.UPDATE));
        } else {
          this.$store.dispatch(New.Actions.Form.CHANGE, { attribute: 'disabilityRate', value: value })
            .then(this.$store.dispatch(New.Actions.Steps.Completed.UPDATE));
        }
      },
      get () {
        return this.period.disabilityRate;
      }
    }
  },
  methods: {
    handleDisabilityRateChanged () {
      this.disabilityRate = Helpers.Percentage.formatAfterChange(this.disabilityRate);
    }
  }
};
</script>

<style>
</style>
